/*
 * Copyright (c) 2020.
 * Simon
 */

import React, {Component} from 'react';
import {ListGroup, ListGroupItem} from 'reactstrap';
import {connect} from "react-redux";
import i18n from "i18next";
import FanpageHearsModal from "./FanpageHearsModal";


class FanpageHearsTable extends Component {

    constructor(props) {
        super(props);

        this.state = {
            hears: {}
        };
    }

    actor() {
        return 'FanpageHearsTable';
    }

    componentWillMount = () => {
        let hears = this.props.hears[this.props.fanpageId];
        this.setState({hears: this.showListByProps(hears)});
    };

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.hearCreateReducer.data === undefined) return;
        let hears = nextProps.hears[nextProps.fanpageId];
        this.setState({hears: this.showListByProps(hears)});
    }

    showListByProps = (hears) => {

        let keys = Object.keys(hears);

        if (keys.length === 0) {
            return (
                <ListGroupItem>{i18n.t('No data')}</ListGroupItem>
            );
        }

        return (
            keys.map(function (key) {
                let hearData = hears[key];

                return (
                    <ListGroupItem
                        action
                        className="pointer"
                        key={key}
                        id={hearData['hear_id']}
                        onClick={(e) => {
                            FanpageHearsModal.chooseHearById(e.target.id, hearData['hear'])
                        }}
                    >
                        {hearData.hear}
                    </ListGroupItem>
                );
            })
        );
    };

    render() {
        return (
            <span>
                <ListGroup>
                    <ListGroupItem active><strong>{i18n.t('Hears')}</strong></ListGroupItem>
                    {this.state.hears}
                </ListGroup>
            </span>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        hears: state.HearsReducer,
        hearCreateReducer: state.HearCreateReducer,
    }
};

const mapDispatchToProps = () => {
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(FanpageHearsTable);


